/* PRISKEL — header shell: search, account sheet, wishlist feedback, shared sheet helpers */
(function () {
  if (window.__pkShell) return;
  window.__pkShell = 1;
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- shared sheet helpers (used by search, account and the bag) ---------- */
  var PK = window.PK = window.PK || {};
  PK.open = function (dlg, opener) {
    if (!dlg || dlg.open) return;
    dlg.__opener = opener || document.activeElement;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    root.classList.add('pk-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-in'); }); });
  };
  PK.close = function (dlg, cb) {
    if (!dlg || !dlg.open) { if (cb) cb(); return; }
    dlg.classList.remove('is-in');
    setTimeout(function () {
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      if (!document.querySelector('dialog[open].pk-sheet,dialog[open].pk-sx,dialog[open].pk-menu')) root.classList.remove('pk-lock');
      if (cb) cb();
    }, reduce ? 0 : 300);
  };
  PK.wire = function (dlg) {
    if (!dlg || dlg.__wired) return;
    dlg.__wired = 1;
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); PK.close(dlg); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-pk-sheet-close],[data-pk-sx-close]')) PK.close(dlg); });
  };
  PK.money = function (paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); };
  PK.toast = function (html, opts) {
    var t = document.querySelector('[data-pk-toast]');
    if (!t) return;
    opts = opts || {};
    t.innerHTML = html;
    t.classList.toggle('is-wl', !!opts.wl);
    t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    clearTimeout(t.__t);
    t.__t = setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.hidden = true; t.classList.remove('is-wl'); }, 320); }, opts.ms || 3200);
  };
  function closeMenuThen(fn) {
    var menu = document.getElementById('pk-menu');
    if (menu && menu.open) {
      var x = menu.querySelector('[data-pk-menu-close]');
      if (x) x.click();
      setTimeout(fn, reduce ? 0 : 300);
    } else fn();
  }

  /* ---------------------------------- search ---------------------------------- */
  var sx = document.getElementById('pk-search');
  if (sx) {
    PK.wire(sx);
    var input = sx.querySelector('[data-pk-sx-input]');
    var idle = sx.querySelector('[data-pk-sx-idle]');
    var res = sx.querySelector('[data-pk-sx-res]');
    var timer = null, ctrl = null, lastQ = '';
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function inr(v) { var n = parseFloat(v); return isFinite(n) ? '₹' + Math.round(n).toLocaleString('en-IN') : ''; }
    function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function show(q) {
      q = (q || '').trim();
      if (q === lastQ) return;
      lastQ = q;
      if (!q) { res.hidden = true; idle.hidden = false; res.innerHTML = ''; return; }
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      res.classList.add('is-loading');
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (q !== lastQ) return;
          var r = (d && d.resources && d.resources.results) || {};
          var ps = r.products || [], cs = r.collections || [], qs = r.queries || [];
          var html = '';
          if (!ps.length && !cs.length) {
            html = '<div class="pk-sx__none"><p class="pk-sx__none-t">Nothing found for “' + esc(q) + '”.</p><p>Try “hoops”, “bracelet” or browse our <a href="/collections/best-sellers-jewellery-india">best sellers</a>.</p></div>';
          } else {
            html += '<div class="pk-sx__grid">';
            if (qs.length || cs.length) {
              html += '<aside class="pk-sx__side">';
              if (qs.length) {
                html += '<p class="pk-hd__ey">Suggestions</p><ul role="list">';
                qs.slice(0, 5).forEach(function (s) { html += '<li><a href="' + esc(s.url) + '">' + (s.styled_text || esc(s.text)) + '</a></li>'; });
                html += '</ul>';
              }
              if (cs.length) {
                html += '<p class="pk-hd__ey">Collections</p><ul role="list">';
                cs.slice(0, 4).forEach(function (c) { html += '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; });
                html += '</ul>';
              }
              html += '</aside>';
            }
            html += '<div class="pk-sx__main"><p class="pk-hd__ey">Products</p><ul class="pk-sx__ps" role="list">';
            ps.slice(0, 8).forEach(function (p) {
              var im = p.image || (p.featured_image && p.featured_image.url) || '';
              var was = parseFloat(p.compare_at_price_max), now = parseFloat(p.price);
              html += '<li><a class="pk-sx__p" href="' + esc(p.url) + '"><span class="pk-sx__p-im">' + (im ? '<img src="' + esc(img(im, 400)) + '" alt="" loading="lazy" width="200" height="250">' : '') + '</span>' +
                '<span class="pk-sx__p-t">' + esc(String(p.title).replace(/ for Women$/i, '')) + '</span>' +
                '<span class="pk-sx__p-pr"><b>' + inr(p.price) + '</b>' + (was > now ? '<s>' + inr(was) + '</s>' : '') + '</span></a></li>';
            });
            html += '</ul></div></div>';
            html += '<a class="pk-sx__all" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for “' + esc(q) + '” <svg width="18" height="10" viewBox="0 0 18 10" fill="none" aria-hidden="true"><path d="M0 5h16M12 1l4 4-4 4" stroke="currentColor" stroke-width="1.2"/></svg></a>';
          }
          res.innerHTML = html;
          idle.hidden = true;
          res.hidden = false;
          res.classList.remove('is-loading');
        })
        .catch(function () { res.classList.remove('is-loading'); });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { show(input.value); }, 200); });
    sx.addEventListener('click', function (e) {
      var term = e.target.closest('[data-pk-sx-term]');
      if (term) { e.preventDefault(); input.value = term.getAttribute('data-pk-sx-term'); show(input.value); input.focus(); }
    });
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-pk-search-open],[aria-controls="drawer-search-form"]');
      if (!o) return;
      e.preventDefault();
      closeMenuThen(function () { PK.open(sx, o); setTimeout(function () { input.focus(); input.select(); }, 60); });
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === '/' && !/input|textarea|select/i.test((document.activeElement || {}).tagName || '') && !sx.open) { e.preventDefault(); PK.open(sx); setTimeout(function () { input.focus(); }, 60); }
    });
  }

  /* --------------------------------- account ---------------------------------- */
  var acct = document.getElementById('pk-acct');
  if (acct) {
    PK.wire(acct);
    var tEl = document.querySelector('[data-pk-toast]');
    var signedIn = !!(tEl && tEl.getAttribute('data-cust') === '1');
    /* OTP+ (mobile OTP / Google / email) handles sign-in for signed-out visitors when its
       app embed is live; this panel is the fallback and the signed-in account menu. */
    var otpReady = function () { return !signedIn && window.__otpAccountInterceptReady === true; };
    var openOtp = function () {
      var a = document.createElement('a');
      a.href = '/account'; a.hidden = true; a.setAttribute('data-pk-otp', '');
      acct.appendChild(a);
      a.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, button: 0 }));
      setTimeout(function () { if (a.parentNode) a.parentNode.removeChild(a); }, 0);
    };
    /* let OTP+ take the click; from inside the open mobile menu, close the menu first */
    var toOtp = function (e, el) {
      var menu = document.getElementById('pk-menu');
      if (menu && menu.open && menu.contains(el)) { e.preventDefault(); e.stopPropagation(); closeMenuThen(openOtp); }
    };
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-pk-acct-open]');
      if (!o) return;
      if (otpReady()) { toOtp(e, o); return; }
      e.preventDefault();
      closeMenuThen(function () { PK.open(acct, o); });
    }, true);
    /* Signed-out visitors without OTP+: every sign-in / account / orders link opens this
       panel first, so mobile OTP and email are always offered (instead of jumping straight
       to Shopify's email-only page). Links inside the panel itself are left alone. */
    var isAcctLink = function (a) {
      var h = a.getAttribute('href') || '';
      var u; try { u = new URL(h, location.href); } catch (err) { return false; }
      if (/logout/i.test(u.pathname)) return false;
      var host = location.hostname.replace(/^www\./, '');
      if (u.hostname.replace(/^www\./, '') === host) return /^\/(account|customer_authentication)(\/|$)/.test(u.pathname);
      return /^account\./.test(u.hostname) && u.hostname.slice(8).replace(/^www\./, '') === host;
    };
    /* Signed in: the panel's Orders / Profile links open the OTP+ account window (orders,
       profile, addresses) after the panel closes, instead of stacking under it. */
    if (signedIn) document.addEventListener('click', function (e) {
      if (window.__otpAccountInterceptReady !== true || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || !acct.contains(a) || a.hasAttribute('data-pk-otp') || !isAcctLink(a)) return;
      e.preventDefault(); e.stopPropagation();
      var tab = /order|track/i.test(a.textContent) ? /my orders/i : /address/i.test(a.textContent) && !/profile/i.test(a.textContent) ? /addresses/i : null;
      PK.close(acct, function () {
        openOtp();
        if (!tab) return;
        var n = 0, iv = setInterval(function () {
          var b = [].filter.call(document.querySelectorAll('#otp-nca-account-modal .otp-account-dashboard__nav-item'), function (x) { return tab.test(x.textContent); })[0];
          if (b) { clearInterval(iv); b.click(); } else if (++n > 30) clearInterval(iv);
        }, 100);
      });
    }, true);
    if (!signedIn) document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || acct.contains(a) || a.hasAttribute('data-pk-acct-open') || a.hasAttribute('data-pk-wl-login')) return;
      if (!isAcctLink(a)) return;
      if (otpReady()) { toOtp(e, a); return; }
      e.preventDefault(); e.stopPropagation();
      closeMenuThen(function () { PK.open(acct, a); });
    }, true);
    PK.openAccount = function (opener) { closeMenuThen(function () { if (otpReady()) openOtp(); else PK.open(acct, opener); }); };
    var mob = acct.querySelector('[data-pk-login-mobile]');
    if (mob) mob.addEventListener('click', function () {
      PK.close(acct, function () {
        if (otpReady()) { openOtp(); return; }
        if (typeof window.shipRocketMarketingLogin === 'function') { try { window.shipRocketMarketingLogin(); return; } catch (err) {} }
        window.location.href = '/account/login';
      });
    });
  }

  /* --------------------------- wishlist count + toast -------------------------- */
  function zero(el) { var v = (el.textContent || '').trim(); el.setAttribute('data-zero', (v === '' || v === '0') ? '1' : '0'); }
  [].forEach.call(document.querySelectorAll('[data-pk-zero]'), function (el) {
    zero(el);
    new MutationObserver(function () { zero(el); }).observe(el, { childList: true, characterData: true, subtree: true });
  });
  var toastEl = document.querySelector('[data-pk-toast]');
  var isCust = !!(toastEl && toastEl.getAttribute('data-cust') === '1');
  var WL_URL = '/search?view=wishlist';
  var HRT = '<svg class="pk-toast__hrt" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.9l-1.52-1.4C5.1 14.63 2.2 12 2.2 8.72 2.2 6.13 4.2 4.1 6.77 4.1c1.46 0 2.86.68 3.77 1.76L12 7.5l1.46-1.64c.91-1.08 2.31-1.76 3.77-1.76 2.57 0 4.57 2.03 4.57 4.62 0 3.28-2.9 5.91-8.28 10.78L12 20.9z"/></svg>';
  function savedCard() {
    var cta = isCust
      ? '<a class="pk-toast__vw" href="' + WL_URL + '">View wishlist</a>'
      : '<a class="pk-toast__btn" href="/account/login" data-pk-wl-login>Sign in to save it</a><a class="pk-toast__vw" href="' + WL_URL + '">View</a>';
    var sub = isCust ? '' : '<small>Keep your wishlist safe across devices</small>';
    return '<span class="pk-toast__ic">' + HRT + '</span>'
         + '<span class="pk-toast__tx"><strong>Saved to your wishlist</strong>' + sub + '</span>'
         + '<span class="pk-toast__ax">' + cta + '</span>';
  }
  document.addEventListener('click', function (e) {
    var lg = e.target.closest && e.target.closest('[data-pk-wl-login]');
    if (lg) {
      e.preventDefault();
      PK.toast('', { ms: 1 });
      if (typeof PK.openAccount === 'function') { PK.openAccount(lg); return; }
      if (typeof window.shipRocketMarketingLogin === 'function') { try { window.shipRocketMarketingLogin(); return; } catch (err) {} }
      window.location.href = '/account/login';
      return;
    }
    var w = e.target.closest && e.target.closest('hdt-wishlist');
    if (!w || w.closest('.pk-hd')) return;
    var before = w.getAttribute('action');
    setTimeout(function () {
      var after = w.getAttribute('action');
      if (after === before) return;
      if (after === 'remove' || after === 'added') PK.toast(savedCard(), { wl: true, ms: isCust ? 3600 : 6500 });
      else if (after === 'add') PK.toast('<span class="pk-toast__ic">' + HRT + '</span><span class="pk-toast__tx"><strong>Removed from your wishlist</strong></span>', { wl: true, ms: 2600 });
    }, 450);
  }, true);
})();

/* OTP+ sign-in card: mobile OTP first, no Google, email goes to Shopify's own sign-in */
(function () {
  var EMAIL_URL = '/customer_authentication/login?return_to=' + encodeURIComponent('/account');
  var MAIL = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="3" y="5.5" width="18" height="13" rx="1.5"/><path d="M3.8 6.5 12 13l8.2-6.5"/></svg>';
  var hide = function (el) { if (el && !el.hasAttribute('data-pk-hidden')) { el.setAttribute('data-pk-hidden', ''); el.style.setProperty('display', 'none', 'important'); } };
  var tidy = function () {
    var m = document.getElementById('otp-nca-account-modal');
    if (!m) return;
    m.querySelectorAll('.otp-card').forEach(function (card) {
      card.querySelectorAll('.otp-btn--google').forEach(hide);
      card.querySelectorAll('.otp-divider').forEach(function (d) { if (!d.hasAttribute('data-pk-or')) hide(d); });
      var phoneStep = card.querySelector('.otp-field__country, input[type="tel"]') && !card.querySelector('.otp-code-box');
      var native = [].filter.call(card.querySelectorAll('a,button'), function (b) { return !b.closest('[data-pk-email]') && /sign\s*in\s*with\s*email|continue\s*with\s*email|use\s*email/i.test(b.textContent || ''); });
      native.forEach(hide);
      var mine = card.querySelector('[data-pk-email]');
      if (!phoneStep) { if (mine) mine.remove(); return; }
      if (mine) return;
      var box = document.createElement('div');
      box.setAttribute('data-pk-email', '');
      box.className = 'pk-otp-email';
      box.innerHTML = '<div class="otp-divider" data-pk-or>or</div>' +
        '<a class="pk-otp-email__btn" href="' + EMAIL_URL + '" data-pk-email-login>' + MAIL + '<span>Continue with email</span></a>' +
        '<p class="pk-otp-email__note">We’ll email you a secure 6-digit code</p>';
      var anchor = native[0];
      if (anchor && anchor.parentNode && card.contains(anchor)) anchor.parentNode.insertBefore(box, anchor);
      else card.appendChild(box);
    });
  };
  window.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pk-email-login]');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    location.href = EMAIL_URL;
  }, true);
  var mo = new MutationObserver(function () { tidy(); });
  var start = function () { tidy(); mo.observe(document.body, { childList: true, subtree: true }); };
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
